import { render } from "./TableViewHistorialCrediticio.vue?vue&type=template&id=0e55a93d&scoped=true&ts=true"
import script from "./TableViewHistorialCrediticio.vue?vue&type=script&lang=ts"
export * from "./TableViewHistorialCrediticio.vue?vue&type=script&lang=ts"

import "./TableViewHistorialCrediticio.vue?vue&type=style&index=0&id=0e55a93d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e55a93d"]])

export default __exports__